import styled from 'styled-components'
import {FaBoxOpen} from 'react-icons/fa'
import ThumbUpIcon from '@material-ui/icons/ThumbUp';

export const Tabs = styled.div`
    display: flex;
    border-bottom: 1px solid #e9e9e9;
    
`

export const Tab = styled.div`
    background-color: #fbfbfb;
    padding: 18px 16px 16px 20px;
    color: #222;
    font-size: 15px;
    display: flex;
    align-items: center;
    cursor: pointer;
    min-width: 245px;
    font-weight: 500;
    border-bottom: 2px solid transparent;

    &.active {
        color: #e32;
        border-bottom: 2px solid #e32;
        font-weight: 700;
    }
    
    @media screen and (max-width: 767px) {
        min-width: 50%;
        padding: 14px 12px 12px 16px;
        font-size: 13px;
        border-left: 1px solid transparent;
        &.active {
            border-left: 1px solid #E6E6E6;
        }
    }
`

export const AllIc = styled(FaBoxOpen)`
    margin-right: 8px;
    font-size: 17px;

`

export const LikeIc = styled(ThumbUpIcon)`
    margin-right: 8px;
    font-size: 17px;

    @media screen and (max-width: 767px) {
        font-size: 18px !important;
    }
`

export const BorderLeft = styled.div`
    border-left: 1px solid #e9e9e9;
    height: 100%;

    @media screen and (max-width: 1023px) {
        border: none;
    }
`

export const ListTitle = styled.p`
    color: #222;
    font-size: 14px;
    font-weight: bold;
    padding: 15px 0 15px 19px;
`

export const ViewMore = styled.button`
    width: 100%;
    outline: none;
    background: #F0F0F0;
    border: 1px solid #ccc;
    padding: 7px 0;
    font-size: 14px;
    color: #222;
    border-radius: 2px;
    cursor: pointer;
`